import { yupResolver } from "@hookform/resolvers/yup"
import ControllerInput from 'base/ControllerInput'
import FormCadastro, { FormCadastroAux } from 'base/FormCadastro'
import GridForm from 'base/GridForm'
import OutputSpanForm from 'base/OutputSpanForm'
import CategoriaPessoaService from 'business/cadastro/pessoa/categoriaPessoa/categoriaPessoaService'
import ClassificacaoPessoaService from 'business/cadastro/pessoa/classificacaoPessoa/classificacaoPessoaService'
import EscolaridadeService from 'business/cadastro/pessoa/escolaridade/escolaridadeService'
import EstadoCivilService from 'business/cadastro/pessoa/estadoCivil/estadoCivilService'
import GrupoPessoaService from 'business/cadastro/pessoa/grupoPessoa/grupoPessoaService'
import HobbyService from 'business/cadastro/pessoa/hobby/hobbyService'
import UsuarioService from 'business/cadastro/pessoa/usuario/usuarioService'
import ProfissaoService from 'business/cadastro/pessoa/profissao/profissaoService'
import SexoService from 'business/cadastro/pessoa/sexo/sexoService'
import { defaultEmptySelection } from 'helper/default'
import { errorToToast } from 'helper/error'
import { clearMili, formatDatetime, getMask } from 'helper/formater'
import { generateCPF } from 'helper/generate'
import { Button } from 'primereact/button'
import { confirmDialog } from 'primereact/confirmdialog'
import { Divider } from 'primereact/divider'
import { TabPanel, TabView } from 'primereact/tabview'
import { useEffect, useRef, useState } from 'react'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import { Message } from "primereact/message"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { Dropdown } from "primereact/dropdown"
import PerfilService from "business/cadastro/perfil/perfilService"
import { InputSwitch } from "primereact/inputswitch"
import axios from "axios"
import { Avatar } from "primereact/avatar"
import * as auth from "infra/localStorage.js"
import { addConfirmTag, addRequestTag, getCustomPresignedPost } from "helper/bucket"
import ModalCropper from "base/cropper/modalCropper/ModalCropper"

export default function Usuario() {

    const [service] = useState(() => new UsuarioService())

    const [municipiosBox, setMunicipiosBox] = useState(null)
    const stepperRef = useRef(null)
    const toast = useRef(null)
    const { id } = useParams()
    const [validations, setValidations] = useState([])
    const [escolaridadeList, setEscolaridadeList] = useState([])
    const [hobbyList, setHobbyList] = useState([])
    const [estadoCivilList, setEstadoCivilList] = useState([])
    const [sexoList, setSexoList] = useState([])
    const [pessoaEnderecoTipoList, setPessoaEnderecoTipoList] = useState([])
    const [registro, setRegistro] = useState({})
    const [profissaoList, setProfissaoList] = useState([])
    const [classificacaoPessoaList, setClassificacaoPessoaList] = useState([])
    const [grupoPessoaList, setGrupoPessoaList] = useState([])
    const [categoriaPessoaList, setCategoriaPessoaList] = useState([])

    const [perfilList, setPerfilList] = useState([])
    const [perfiLoaded, setPerfilLoaded] = useState(false)

    const [binaryImage, setBinaryImage] = useState(null)
    const inputImageRef = useRef(null)  // Referência para o <input> escondido

    const [avatarImage, setAvatarImage] = useState(null)
    const [inputKey, setInputKey] = useState(Date.now())
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [selectedImage, setSelectedImage] = useState(null)

    const DEF = { RESIDENCIAL: 1, REGISTRO: 5 }

    const form = useForm({
        defaultValues: async () => await load(),
        resolver: yupResolver(validations),
        mode: "onBlur"
    })

    const pessoaEndereco = useFieldArray({
        control: form.control,
        name: "pessoa_fisica.pessoa.pessoa_endereco"
    })

    const usuarioEmpresa = useFieldArray({
        control: form.control,
        name: "usuario_empresa"
    })

    const customSetPerfilList = (list) => {

        let cleanList = []

        list.forEach(perfil => {
            if (!cleanList.find(e => e.codigo_perf === perfil.codigo_perf)) {
                cleanList.push(perfil)
            }
        })

        cleanList.sort((a, b) => a.descricao_perf.localeCompare(b.descricao_perf))
        setPerfilList(cleanList)
    }

    async function load() {
        const data = await FormCadastroAux.load({ id, service, toast, beforeSubmit, useNew: true })

        if (data.pessoa_fisica.pessoa.ref_img_pes) {
            const imgUrl = `${auth.getData().bucketPath}/pessoa/${data.pessoa_fisica.pessoa.ref_img_pes}`
            setAvatarImage(imgUrl)
        }

        if (data.pessoa_fisica.escolaridade) {
            const escolaridade = { codigo_esco: data.pessoa_fisica.escolaridade?.codigo_esco, descricao_esco: data.pessoa_fisica.escolaridade?.descricao_esco }
            setEscolaridadeList([escolaridade])
            data.pessoa_fisica.cod_esco_pef = escolaridade
        }

        if (data.pessoa_fisica.hobby) {
            const hobby = { codigo_hobb: data.pessoa_fisica.hobby?.codigo_hobb, descricao_hobb: data.pessoa_fisica.hobby?.descricao_hobb }
            setHobbyList([hobby])
            data.pessoa_fisica.cod_hobb_pef = hobby
        }

        if (data.pessoa_fisica.estado_civil) {
            const estadoCivil = { codigo_esci: data.pessoa_fisica.estado_civil?.codigo_esci, descricao_esci: data.pessoa_fisica.estado_civil?.descricao_esci }
            setEstadoCivilList([estadoCivil])
            data.pessoa_fisica.cod_esci_pef = estadoCivil
        }

        if (data.pessoa_fisica.sexo) {
            const sexo = { codigo_sexo: data.pessoa_fisica.sexo?.codigo_sexo, descricao_sexo: data.pessoa_fisica.sexo?.descricao_sexo }
            setSexoList([sexo])
            data.pessoa_fisica.cod_sexo_pef = sexo
        }

        if (data.pessoa_fisica.profissao) {
            const profissao = { codigo_prof: data.pessoa_fisica.profissao?.codigo_prof, descricao_prof: data.pessoa_fisica.profissao?.descricao_prof }
            setProfissaoList([profissao])
            data.pessoa_fisica.cod_prof_pef = profissao
        }

        if (data.pessoa_fisica.pessoa.classificacao_pessoa) {
            const classificacaoPessoa = { codigo_clap: data.pessoa_fisica.pessoa.classificacao_pessoa?.codigo_clap, descricao_clap: data.pessoa_fisica.pessoa.classificacao_pessoa?.descricao_clap }
            setClassificacaoPessoaList([classificacaoPessoa])
            data.pessoa_fisica.pessoa.cod_clap_pes = classificacaoPessoa
        }

        if (data.pessoa_fisica.pessoa.grupo_pessoa) {
            const grupoPessoa = { codigo_grup: data.pessoa_fisica.pessoa.grupo_pessoa?.codigo_grup, descricao_grup: data.pessoa_fisica.pessoa.grupo_pessoa?.descricao_grup }
            setGrupoPessoaList([grupoPessoa])
            data.pessoa_fisica.pessoa.cod_grup_pes = grupoPessoa
        }

        if (data.pessoa_fisica.pessoa.categoria_pessoa) {
            const categoriaPessoa = { codigo_catp: data.pessoa_fisica.pessoa.categoria_pessoa?.codigo_catp, descricao_catp: data.pessoa_fisica.pessoa.categoria_pessoa?.descricao_catp }
            setCategoriaPessoaList([categoriaPessoa])
            data.pessoa_fisica.pessoa.cod_catp_pes = categoriaPessoa
        }

        if (data.usuario_empresa) {
            const perfis = []

            for (const usem of data.usuario_empresa) {
                if (usem?.perfil?.codigo_perf) {
                    perfis.push(service.getElementPerfil(usem.perfil))
                }
            }

            customSetPerfilList(perfis)

        }

        startMunicipiosBox(data)
        setPessoaEnderecoTipoList([...data.pessoa_fisica.meta.pessoa_endereco_tipo])

        service.addEnderecoResidencial(data.pessoa_fisica.pessoa)
        service.enderecosCodigoToObject(data.pessoa_fisica.pessoa, data.pessoa_fisica.meta.pessoa_endereco_tipo)

        // form.reset(data, { keepDirty: false, keepDirtyValues: false })

        return data

    }

    const startMunicipiosBox = (data) => {

        const muns = data.pessoa_fisica.pessoa.pessoa_endereco.map(e => service.formatMunicipioOption(e.municipio.codigo_muni, e.municipio.descricao_muni, e.municipio.uf.sigla_uf))
        setMunicipiosBox(muns)

    }

    const beforeSubmit = (data) => {

        let submitData = structuredClone(data)

        const { dirtyFields } = form.formState

        // Se tem campos alterados
        if (dirtyFields?.pessoa_fisica?.pessoa) {
            service.formatActionOfEnderecos(submitData?.pessoa_fisica.pessoa, dirtyFields?.pessoa_fisica.pessoa)
        }

        submitData = service.prepareToSave({ data: submitData })

        return submitData

    }

    useEffect(() => {
        service.getSchema().then(setValidations)
    }, [service])

    const loadProfissaoList = async () => {
        const prf = new ProfissaoService()
        await prf.list('').then(rs => {
            const data = rs.data.data.map(e => ({ codigo_prof: e.codigo_prof, descricao_prof: e.descricao_prof }))
            data.push({ codigo_prof: null, descricao_prof: defaultEmptySelection() })
            setProfissaoList(data)
        }).catch(err => errorToToast({ err, toast }))
    }

    const loadClassificacaoPessoaList = async () => {
        const clap = new ClassificacaoPessoaService()
        await clap.list('?cod_tipe_grup=f&cod_tipe_grup=null').then(rs => {
            const data = rs.data.data.map(e => ({ codigo_clap: e.codigo_clap, descricao_clap: e.descricao_clap }))
            data.push({ codigo_clap: null, descricao_clap: defaultEmptySelection() })
            setClassificacaoPessoaList(data)
        }).catch(err => errorToToast({ err, toast }))
    }

    const loadGrupoPessoaList = async () => {
        const grup = new GrupoPessoaService()
        await grup.list('?cod_tipe_grup=f&cod_tipe_grup=null').then(rs => {
            const data = rs.data.data.map(e => ({ codigo_grup: e.codigo_grup, descricao_grup: e.descricao_grup }))
            data.push({ codigo_grup: null, descricao_grup: defaultEmptySelection() })
            setGrupoPessoaList(data)
        }).catch(err => errorToToast({ err, toast }))
    }

    const loadCategoriaPessoaList = async () => {
        const catp = new CategoriaPessoaService()
        await catp.list('?cod_tipe_catp=f&cod_tipe_catp=null').then(rs => {
            const data = rs.data.data.map(e => ({ codigo_catp: e.codigo_catp, descricao_catp: e.descricao_catp }))
            data.push({ codigo_catp: null, descricao_catp: defaultEmptySelection() })
            setCategoriaPessoaList(data)
        }).catch(err => errorToToast({ err, toast }))
    }

    const loadEscolaridadeList = async () => {
        const esco = new EscolaridadeService()
        await esco.list('').then(rs => {
            const data = rs.data.data.map(e => ({ codigo_esco: e.codigo_esco, descricao_esco: e.descricao_esco }))
            data.push({ codigo_esco: null, descricao_esco: defaultEmptySelection() })
            setEscolaridadeList(data)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadHobbyList = async () => {
        const hobb = new HobbyService()
        await hobb.list('').then(rs => {
            const data = rs.data.data.map(e => ({ codigo_hobb: e.codigo_hobb, descricao_hobb: e.descricao_hobb }))
            data.push({ codigo_hobb: null, descricao_hobb: defaultEmptySelection() })
            setHobbyList(data)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadEstadoCivilList = async () => {
        const esci = new EstadoCivilService()
        await esci.list('').then(rs => {
            const data = rs.data.data.map(e => ({ codigo_esci: e.codigo_esci, descricao_esci: e.descricao_esci }))
            data.push({ codigo_esci: null, descricao_esci: defaultEmptySelection() })
            setEstadoCivilList(data)
        }).catch(err => errorToToast({ err, toast }))
    }
    const loadSexoList = async () => {
        const sex = new SexoService()
        await sex.list('').then(rs => {
            const data = rs.data.data.map(e => ({ codigo_sexo: e.codigo_sexo, descricao_sexo: e.descricao_sexo }))
            data.push({ codigo_sexo: null, descricao_sexo: defaultEmptySelection() })
            setSexoList(data)
        }).catch(err => errorToToast({ err, toast }))
    }

    const municipioSearch = (event) => {

        service.filterMunicipio({ municipio: event.query }).then((response) => {
            const rs = response.data.pessoa_fisica.data
            const formatado = rs.map(e => service.formatMunicipioOption(e.codigo_muni, e.descricao_muni, e.meta.sigla_uf))
            setMunicipiosBox(formatado)
        }).catch((error) => {
            console.log("Erro: ", error)
        })
    }

    const enderecoSearch = async (cep, index) => {

        service.enderecoSearch({
            cep,
            resolve: ({ response, optionMunicipio }) => {
                if (!municipiosBox.some(e => e.codigo_muni === response.ibge)) {
                    const municipiosUnique = municipiosBox
                    municipiosUnique.push(optionMunicipio)
                    setMunicipiosBox(municipiosUnique)
                }
                form.setValue(`pessoa_fisica.pessoa.pessoa_endereco[${index}].descricao_ende`, response.logradouro, { shouldValidate: true, shouldTouch: true })
                form.setValue(`pessoa_fisica.pessoa.pessoa_endereco[${index}].bairro_ende`, response.bairro)
                form.setValue(`pessoa_fisica.pessoa.pessoa_endereco[${index}].cod_muni_ende`, optionMunicipio)
            },
            reject: () => {
                toast.current.show({ severity: 'warn', summary: 'Ops!', detail: `CEP ${cep} não encontrado!`, life: 7000 })
            }
        })

    }

    const loadPerfilList = async () => {
        if (!perfiLoaded) {
            setPerfilLoaded(true)
            const perf = new PerfilService()
            await perf.list('').then(rs => {
                const data = rs.data.data.map(e => ({ codigo_perf: e.codigo_perf, descricao_perf: e.descricao_perf }))
                data.push({ codigo_perf: null, descricao_perf: defaultEmptySelection() })
                customSetPerfilList(data)
            }).catch(err => errorToToast({ err, toast }))
        }
    }

    const onSave = ({ id, dataCopy, navigate, pesquisa, setSaving }) => {

        service.save(id, dataCopy).then(async (_response) => {

            /**
             * Subir arquivo para o s3 usando post pré-assinado!
             */

            if (binaryImage) {

                id = _response.data.codigo_usu

                form.setValue('pessoa_fisica.pessoa.codigo_pes', _response.data.codigo_usu)
                form.setValue('pessoa_fisica.codigo_pef', _response.data.codigo_usu)
                form.setValue('codigo_usu', _response.data.codigo_usu)

                dataCopy.pessoa_fisica.pessoa.dh_atua_pes = clearMili(_response.data.meta.pessoa_fisica.meta.pessoa.dh_atua_pes)
                dataCopy.pessoa_fisica.atualizado_pef = clearMili(_response.data.meta.pessoa_fisica.atualizado_pef)
                dataCopy.dh_atua_usu = clearMili(_response.data.dh_atua_usu)

                dataCopy.pessoa_fisica.pessoa.codigo_pes = _response.data.codigo_usu
                dataCopy.pessoa_fisica.codigo_pef = _response.data.codigo_usu
                dataCopy.codigo_usu = _response.data.codigo_usu

                dataCopy.pessoa_fisica.pessoa.pessoa_endereco.map(e => e.action = '')
                dataCopy.pessoa_fisica.pessoa.pessoaEnderecoRemoved = []

                const post = getCustomPresignedPost({
                    typeName: 'image',
                    presignedPost: _response.data.meta.pessoa_fisica.meta.pessoa.meta.refImgPesPresigned,
                    binaryFile: binaryImage
                })

                try {
                    // Faz o upload para o S3
                    const response = await axios.post(post.url, post.formData, { headers: post.headers })

                    if (response.status === 204) {

                        dataCopy.pessoa_fisica.pessoa.ref_img_pes = addConfirmTag(dataCopy.pessoa_fisica.pessoa.ref_img_pes)

                        // Resaving...
                        await service.save(id, dataCopy).then(async (_response) => {
                            navigate(service.frontUrlList, pesquisa)
                        }).catch((err) => {
                            FormCadastroAux.showExceptions(err)
                        })

                    } else {
                        console.log('Erro inesperado no upload:', response)
                    }
                } catch (error) {
                    console.error('Erro ao fazer upload para o S3:', error)
                }

            } else {
                navigate(service.frontUrlList, pesquisa)
            }
        }).catch((err) => {
            FormCadastroAux.showExceptions(err)
        }).finally(() => setSaving(false))
    }

    const handleImageChange = (event) => {

        const file = event.target.files[0]
        if (file) {
            const url = URL.createObjectURL(file)
            setSelectedImage(url)
            setIsModalVisible(true)
        }

        setInputKey(Date.now())

    }

    const handleSaveCroppedImage = (blob, url) => {

        setAvatarImage(url)
        setBinaryImage(blob)
        form.setValue('pessoa_fisica.pessoa.ref_img_pes', addRequestTag('nameOfFile.png'), { shouldDirty: true })

    }

    const getInitials = () => {

        const initials = form.getValues('pessoa_fisica.pessoa.nome_razao_pes')?.split(' ').map(e => {
            return e[0]
        })

        if (initials) {
            let joined = initials.slice(0, 2).join('').toUpperCase()
            if (joined == 'C' + 'U') joined = 'C'
            return joined
        }

        return ''

    }

    return (

        < FormCadastro service={service} form={form} aux={FormCadastroAux} toast={toast}
            beforeSubmit={beforeSubmit} onSave={onSave}
        >

            <div className='flex flex-row align-items-center gap-2'>

                <input key={inputKey} id="upload-input" type="file" accept="image/*" style={{ display: 'none' }} ref={inputImageRef} onChange={handleImageChange} />

                <Avatar label={getInitials()} image={avatarImage} shape='circle' size='xlarge' className='flex'
                    onImageError={e => {
                        console.log('Image error:', e)
                        setAvatarImage('')
                    }}
                    onError={e => console.log('Error: ', e)}
                />

                <Button label="Alterar" icon="" onClick={e => {
                    e.preventDefault()
                    inputImageRef.current.value = ''
                    inputImageRef.current.click()
                }}
                    text
                />

            </div>

            <ModalCropper
                visible={isModalVisible}
                onHide={() => setIsModalVisible(false)}
                image={selectedImage}
                onSave={handleSaveCroppedImage}
                croppedConfig={{ width: 64, height: 64 }}
            />

            <TabView ref={stepperRef}
                className='text-sm'
                style={{ flexBasis: '1rem' }}
                onBeforeTabChange={async (e) => {
                    if (e.index === DEF.REGISTRO) {
                        if (!registro.data) {
                            const rs = await service.getById({ id, includes: 'registro' })
                            setRegistro(rs.data.meta.registro)
                        }

                    }

                }}
            >

                <TabPanel header="Capa" leftIcon="pi pi-home mr-2">
                    <GridForm>
                        <ControllerInput addClassName="md:col-6 lg:col-6 xl:col-4" field="pessoa_fisica.pessoa.nome_razao_pes" form={form} service={service} type="text" clearString label="Nome"
                            onBlur={(event) => {
                                event.preventDefault()
                                if (event.target.value.includes('Inventad')) {
                                    if (!form.getValues("pessoa_fisica.pessoa.cpf_cnpj_pes")) {
                                        form.setValue("pessoa_fisica.pessoa.cpf_cnpj_pes", generateCPF())
                                        form.setValue("login_usu", (form.getValues('pessoa_fisica.pessoa.nome_razao_pes') + '@inventado.com.inv').replaceAll(' ', '').toLowerCase())
                                    }
                                }
                            }}
                        />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="login_usu" form={form} service={service} type="text" noSpace inputMode="email" label="Login (e-mail)"
                            onBlur={(event) => {
                                form.setValue("pessoa_fisica.pessoa.email_pes", event.target.value)
                                event.preventDefault()
                            }}
                        />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" mask={getMask('cpf')} field="pessoa_fisica.pessoa.cpf_cnpj_pes" form={form} service={service} type="text" inputMode="tel" label="CPF" />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.rg_pef" form={form} service={service} type="text" inputMode="tel" noSpace label=" RG" />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.org_emis_rg_pef" form={form} service={service} type="text" noSpace label="Orgão emissor (RG)" />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.emis_rg_pef" form={form} service={service} type="calendar" inputMode="tel" label="Data da emissão (RG)" />

                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" mask={getMask('cellphone')} field="pessoa_fisica.pessoa.tel_cel_pes" form={form} service={service} type="text" inputMode="tel" label="Celular" />


                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.pessoa.email_pes" form={form} service={service} type="text" noSpace inputMode="email" label="E-mail" />


                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.cnh_pef" form={form} service={service} type="text" inputMode="tel" noSpace label="CNH" />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.nasc_pef" form={form} service={service} type="calendar" inputMode="tel" label="Nascimento" />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.nacionalidade_pef" form={form} service={service} type="text" clearString label="Nacionalidade" />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.naturalidade_pef" form={form} service={service} type="text" clearString label="Naturalidade" />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.cod_esco_pef" form={form} type="dropdown" service={service} label="Escolaridade"
                            optionLabel='descricao_esco'
                            options={escolaridadeList}
                            onLoad={loadEscolaridadeList}
                        />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.cod_sexo_pef" form={form} service={service} type="dropdown" label="Sexo"
                            optionLabel='descricao_sexo'
                            options={sexoList}
                            onLoad={loadSexoList}
                        />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.cod_esci_pef" form={form} service={service} type="dropdown" label="Estado civil"
                            optionLabel='descricao_esci'
                            options={estadoCivilList}
                            onLoad={loadEstadoCivilList}
                        />

                        <Controller
                            name='usuario_empresa'
                            defaultValue={''}
                            control={form.control}
                            render={({ field, fieldState }) => (
                                <DataTable
                                    cellMemo={false}
                                    className="field text-sm col-12 mb-2 md:col-6 lg:col-6 xl:col-4 "
                                    value={field.value}
                                    // editMode="cell"
                                    id="codigo_usem"
                                    dataKey="codigo_usem"
                                    size="small"
                                    showHeaders={true}
                                    showGridlines
                                >
                                    <Column field="pessoaJuridicaEmp.nome_fantasia_pej" header="Empresa"
                                        body={rowData => <span>{`${rowData.pessoaJuridicaEmp.nome_fantasia_pej} - (${rowData.pessoaJuridicaEmp.codigo_pej})`}</span>}
                                        style={{ width: '45%' }} ></Column>
                                    {/* <Column field="cod_perf_usem.codigo_perf" header="Perfil na empresa" style={{ width: '40%' }}
                                        className="m-0 p-0"
                                        body={perfilBody}
                                        editor={(options) => perfilEdit(options)}
                                        onCellEditComplete={(e) => {
                                            // Atualizar o valor no array de campos
                                            // usuarioEmpresa.fields[e.cellIndex].cod_perf_usem = e.newValue
                                            // field.onChange([...usuarioEmpresa.fields]) // Atualizar o campo controlado
                                        }}
                                    ></Column> */}
                                    {/* BODY-2 */}
                                    <Column
                                        className="m-0 p-0"
                                        dataKey={field.value.codigo_usem} field="cod_perf_usem" header="Perfil do usuário" style={{ width: '45%' }}
                                        body={(rowData, { rowIndex }) => (
                                            <Controller
                                                name={`usuario_empresa[${rowIndex}].cod_perf_usem`}
                                                control={form.control}
                                                render={({ field }) => (
                                                    <Dropdown
                                                        value={field.value}
                                                        options={perfilList}
                                                        onClick={loadPerfilList}
                                                        onShow={loadPerfilList}
                                                        optionLabel="descricao_perf"
                                                        onChange={(e) => {
                                                            field.onChange(e.value)
                                                            usuarioEmpresa.update(rowIndex, { ...rowData, cod_perf_usem: e.value })
                                                        }}
                                                        placeholder="Sem perfil"
                                                    />
                                                )}
                                            />
                                        )}
                                    ></Column>
                                    <Column
                                        className="m-0 p-0 text-center"
                                        dataKey={field.value.codigo_usem} field="ativo_usem" header="Ativo" style={{ width: '10%' }}
                                        body={(rowData, { rowIndex }) => (
                                            <Controller
                                                name={`usuario_empresa[${rowIndex}].ativo_usem`}
                                                control={form.control}
                                                render={({ field }) => (
                                                    <InputSwitch
                                                        checked={field.value === 1}
                                                        onChange={(e) => {
                                                            field.onChange(e.value ? 1 : 0)
                                                            usuarioEmpresa.update(rowIndex, { ...rowData, ativo_usem: e.value ? 1 : 0 })
                                                        }}
                                                    />

                                                )}
                                            />
                                        )}
                                    ></Column>
                                </DataTable>
                            )}
                        />

                        {id && <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="meta.sendMailToRegisterTenant" form={form} service={service} type="switch" label="Reenviar link no e-mail ao salvar" />}

                        {pessoaEndereco.fields.map((data, index) => {
                            if (data.cod_tend_ende.codigo_tend !== DEF.RESIDENCIAL) {
                                return null
                            }
                            return (
                                <div key={data.id} className='grid col-12 m-0 p-0'>
                                    <Divider className='flex mt-2 mb-2'></Divider>

                                    <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field={`pessoa_fisica.pessoa.pessoa_endereco[${index}].cep_ende`} form={form} service={service} mask={getMask('cep')} type="text" inputMode="tel" label="CEP"
                                        onBlur={e => enderecoSearch(e.target.value, index)}
                                    />
                                    <ControllerInput addClassName="md:col-4 lg:col-4 xl:col-2" field={`pessoa_fisica.pessoa.pessoa_endereco[${index}].descricao_ende`} form={form} service={service} type="text" clearString label="Endereço" />
                                    <ControllerInput addClassName="md:col-2 lg:col-2 xl:col-2" field={`pessoa_fisica.pessoa.pessoa_endereco[${index}].num_ende`} form={form} service={service} type="text" inputMode="numeric" noSpace label="Número" />
                                    <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field={`pessoa_fisica.pessoa.pessoa_endereco[${index}].compl_ende`} form={form} service={service} type="text" clearString label="Complemento" />
                                    <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field={`pessoa_fisica.pessoa.pessoa_endereco[${index}].bairro_ende`} form={form} service={service} type="text" clearString label="Bairro" />

                                    <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field={`pessoa_fisica.pessoa.pessoa_endereco[${index}].cod_muni_ende`} form={form} service={service} type="autocomplete" label="Municipio"
                                        suggestions={municipiosBox}
                                        completeMethod={municipioSearch}
                                        fieldShow={'descricao_munuf'}
                                    />

                                    <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field={`pessoa_fisica.pessoa.pessoa_endereco[${index}].tel_ende`} mask={getMask('cellphone')} form={form} service={service} type="text" inputMode="tel" label="Telefone" />
                                    <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field={`pessoa_fisica.pessoa.pessoa_endereco[${index}].usa_desde_ende`} form={form} service={service} type="calendar" inputMode="tel" label="Desde" />
                                    <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field={`pessoa_fisica.pessoa.pessoa_endereco[${index}].cod_tend_ende`} form={form} service={service} type="dropdown" label="Endereço de"
                                        optionLabel='descricao_tend'
                                        options={pessoaEnderecoTipoList}
                                        disabled
                                    />
                                </div>
                            )
                        }
                        )}

                    </GridForm>
                </TabPanel>

                <TabPanel header="Endereços" leftIcon="pi pi-directions mr-2">
                    <GridForm>
                        {pessoaEndereco.fields.map((data, index) => {
                            if (data.cod_tend_ende.codigo_tend === DEF.RESIDENCIAL) {
                                return ''
                            }
                            return (
                                <div key={data.id} className='grid col-12 m-0 p-0'>
                                    <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2 font-bold" field={`pessoa_fisica.pessoa.pessoa_endereco[${index}].cod_tend_ende`} form={form} service={service} type="dropdown" label="Endereço de"
                                        optionLabel='descricao_tend'
                                        options={pessoaEnderecoTipoList}
                                        onClick={_ => true}
                                    />
                                    <ControllerInput addClassName="md:col-2 lg:col-2 xl:col-2" field={`pessoa_fisica.pessoa.pessoa_endereco[${index}].nome_ende`} form={form} service={service} type="text" clearString label="Nome" />
                                    <ControllerInput addClassName="md:col-2 lg:col-2 xl:col-2" field={`pessoa_fisica.pessoa.pessoa_endereco[${index}].cep_ende`} form={form} service={service} mask={getMask('cep')} type="text" inputMode="tel" label="CEP"
                                        onBlur={e => enderecoSearch(e.target.value, index)}
                                    />
                                    <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-3" field={`pessoa_fisica.pessoa.pessoa_endereco[${index}].descricao_ende`} form={form} service={service} type="text" clearString label="Endereço" />
                                    <ControllerInput addClassName="md:col-2 lg:col-2 xl:col-1" field={`pessoa_fisica.pessoa.pessoa_endereco[${index}].num_ende`} form={form} service={service} type="text" inputMode="numeric" noSpace label="Número" />
                                    <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field={`pessoa_fisica.pessoa.pessoa_endereco[${index}].compl_ende`} form={form} service={service} type="text" clearString label="Complemento" />
                                    <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field={`pessoa_fisica.pessoa.pessoa_endereco[${index}].bairro_ende`} form={form} service={service} type="text" clearString label="Bairro" />
                                    <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field={`pessoa_fisica.pessoa.pessoa_endereco[${index}].cod_muni_ende`} form={form} service={service} type="autocomplete" label="Municipio"
                                        suggestions={municipiosBox}
                                        completeMethod={municipioSearch}
                                        fieldShow={'descricao_munuf'}
                                    />

                                    <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field={`pessoa_fisica.pessoa.pessoa_endereco[${index}].tel_ende`} mask={getMask('cellphone')} form={form} service={service} type="text" inputMode="tel" label="Telefone" />
                                    <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field={`pessoa_fisica.pessoa.pessoa_endereco[${index}].usa_desde_ende`} form={form} service={service} type="calendar" inputMode="tel" label="Desde" />

                                    <Button
                                        id="btnRmEndereco"
                                        className="md:col-1 lg:col-1 xl:col-1"
                                        label="" icon="pi pi-trash" size="small" onClick={(e) => {
                                            confirmDialog({
                                                message: 'Confirma remover o endereço? ' + index,
                                                icon: 'pi pi-question-circle',
                                                accept: () => {
                                                    const removed = form.getValues(`pessoa_fisica.pessoa.pessoaEnderecoRemoved`) || []
                                                    if (data.codigo_ende) {
                                                        removed.push({ codigo_ende: data.codigo_ende })
                                                        form.setValue('pessoa_fisica.pessoa.pessoaEnderecoRemoved', removed)
                                                    }
                                                    pessoaEndereco.remove(index)
                                                }
                                            })
                                            e.preventDefault()
                                        }}
                                        severity="warning" text
                                    />

                                    {pessoaEndereco.fields.length > 2 && <Divider className='flex mt-2 mb-2'></Divider>}
                                </div>
                            )
                        })}

                        <div className="flex m-2 justify-content-start">
                            <Button
                                onClick={(e) => {
                                    e.preventDefault()
                                    pessoaEndereco.append(service.getNewEndereco(), { shouldFocus: false })
                                }}
                            >Adicionar</Button>

                        </div>

                    </GridForm>
                </TabPanel>
                <TabPanel header="Profissional" leftIcon="pi pi-user mr-2">
                    <GridForm>

                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.cod_prof_pef" form={form} service={service} type="dropdown" label="Profissão"
                            optionLabel='descricao_prof'
                            options={profissaoList}
                            onLoad={loadProfissaoList}
                        />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.tmp_srv_trab_pef" form={form} service={service} type="text" clearString label="Tempo de serviço" />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.renda_mes_pef" form={form} service={service} type="number" inputMode="numeric" clearString label="Renda mensal" />

                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.num_ctps_pef" form={form} service={service} type="text" inputMode="text" noSpace label="Número CTPS" />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.serie_ctps_pef" form={form} service={service} type="text" inputMode="text" noSpace label="Série CTPS" />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.num_pis_pef" form={form} service={service} type="text" inputMode="text" noSpace label="PIS" />
                        <ControllerInput addClassName="md:col-6 lg:col-6 xl:col-2" field="pessoa_fisica.pessoa.id_inter_pes" form={form} service={service} type="text" clearString label="Identif. internacional" />
                        <ControllerInput addClassName="md:col-6 lg:col-6 xl:col-4" field="pessoa_fisica.pessoa.biografia_pes" form={form} service={service} type="text" clearString label="Bio" />
                    </GridForm>
                </TabPanel>

                <TabPanel header="Crédito" leftIcon="pi pi-dollar mr-2">
                    <GridForm>
                        <ControllerInput addClassName="md:col-6 lg:col-6 xl:col-4" field="pessoa_fisica.pessoa.ref_bancaria_pes" form={form} service={service} type="textarea" clearString label="Referências bancárias" rows={5} />
                        <ControllerInput addClassName="md:col-6 lg:col-6 xl:col-4" field="pessoa_fisica.ref_pessoal_pef" form={form} service={service} type="textarea" clearString label="Referências pessoais" rows={5} />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.pessoa.lim_cred_pes" form={form} service={service} type="number" inputMode="numeric" noSpace label="Limite de crédito" />

                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.pessoa.cli_atac_pes" form={form} service={service} type="switch" label="Atacadista" />
                    </GridForm>
                </TabPanel>
                <TabPanel header="Mais" leftIcon="pi pi-wrench mr-2">
                    <GridForm>
                        <ControllerInput addClassName="md:col-4 lg:col-4 xl:col-2" field="pessoa_fisica.pessoa.cod_clap_pes" form={form} service={service} type="dropdown" label="Classificação"
                            optionLabel='descricao_clap'
                            options={classificacaoPessoaList}
                            onLoad={loadClassificacaoPessoaList}
                        />
                        <ControllerInput addClassName="md:col-4 lg:col-4 xl:col-2" field="pessoa_fisica.pessoa.cod_grup_pes" form={form} service={service} type="dropdown" label="Grupo"
                            optionLabel='descricao_grup'
                            options={grupoPessoaList}
                            onLoad={loadGrupoPessoaList}
                        />

                        <ControllerInput addClassName="md:col-4 lg:col-4 xl:col-2" field="pessoa_fisica.pessoa.cod_catp_pes" form={form} service={service} type="dropdown" label="Categoria"
                            optionLabel='descricao_catp'
                            options={categoriaPessoaList}
                            onLoad={loadCategoriaPessoaList}
                        />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.cod_hobb_pef" form={form} service={service} type="dropdown" label="Hobby"
                            optionLabel='descricao_hobb'
                            options={hobbyList}
                            onLoad={loadHobbyList}
                        />

                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" mask={getMask('cellphone')} field="pessoa_fisica.pessoa.tel_comercial_pes" form={form} service={service} type="text" inputMode="tel" label="Fone comercial" />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.pessoa.email_fina_pes" form={form} service={service} type="text" noSpace inputMode="email" label="E-mail (financeiro)" />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.pessoa.ie_pes" form={form} service={service} type="text" inputMode="text" noSpace label="IE" />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.pessoa.ins_muni_pes" form={form} type="text" noSpace service={service} label="Inscrição municipal" />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-2" field="pessoa_fisica.pessoa.tratamento_pes" form={form} service={service} type="text" clearString label="Tratamento" />
                        <ControllerInput addClassName="md:col-3 lg:col-3 xl:col-3" field="pessoa_fisica.pessoa.nome_social_pes" form={form} service={service} type="text" clearString label="Nome social" />
                        <ControllerInput addClassName="md:col-6 lg:col-6 xl:col-3" field="pessoa_fisica.nome_conjuge_pef" form={form} service={service} type="text" clearString label="Conjuge" />
                        <ControllerInput addClassName="md:col-6 lg:col-6 xl:col-3" field="pessoa_fisica.nome_pai_pef" form={form} service={service} type="text" clearString label="Nome do pai" />
                        <ControllerInput addClassName="md:col-6 lg:col-6 xl:col-3" field="pessoa_fisica.nome_mae_pef" form={form} service={service} type="text" clearString label="Nome da mãe" />
                        <ControllerInput addClassName="md:col-6 lg:col-6 xl:col-6" field="pessoa_fisica.obs_pef" form={form} service={service} type="textarea" clearString label="Observações" rows={3} />

                    </GridForm>
                </TabPanel>

                <TabPanel header="Info" leftIcon="pi pi-info-circle mr-2" visible={id > 0} >
                    <GridForm>

                        <OutputSpanForm field="usu_ins_pes" className="col-12 md:col-4 lg:col-4 xl:col-3" value={form.getValues('pessoa_fisica.pessoa.usu_ins_pes') + ' - ' + registro?.meta?.nome_razao_usu_ins} label="Inserido por" />
                        <OutputSpanForm field="cod_emp_pes" className="col-12 md:col-4 lg:col-4 xl:col-3" value={form.getValues('pessoa_fisica.pessoa.cod_emp_pes') + ' - ' + registro?.meta?.nome_razao_emp} label="Na empresa" />
                        <OutputSpanForm field="pessoa_fisica.pessoa.dh_ins_pes" className="col-12 md:col-4 lg:col-4 xl:col-3" form={form} value={formatDatetime(form.getValues('pessoa_fisica.pessoa.dh_ins_pes'))} label="Inserido em" />
                        <OutputSpanForm field="usu_atua_pes" className="col-12 md:col-4 lg:col-4 xl:col-3" value={form.getValues('pessoa_fisica.pessoa.usu_atua_pes') + ' - ' + registro?.meta?.nome_razao_usu_atu} label="Atualizado por" />
                        <OutputSpanForm field="pessoa_fisica.pessoa.dh_atua_pes" className="col-12 md:col-4 lg:col-4 xl:col-3" form={form} value={formatDatetime(form.getValues('pessoa_fisica.pessoa.dh_atua_pes'))} label="Atualizado em" />

                    </GridForm>
                </TabPanel>


            </TabView>

            <Message severity="info" text={UsuarioService.help()}
                className='mt-4'
            />

            {/* <Button
                icon={`pi ${smileRunning ? 'pi-spin' : ''} pi-face-smile`}
                outlined
                text
                onClick={e => {
                    e.preventDefault()
                    setSmileRunning(true)

                    server().get('cadastro/pessoa/usuarios3test').then(async (response) => {
                        console.log(response)

                    }).catch(err => errorToToast({ err, toast, alt: 'Erro desconhecido' }))
                        .finally(e => {
                            setSmileRunning(false)
                        })
                }}
            ></Button> */}

        </FormCadastro >
    )
}
